module.exports = __webpack_public_path__ + "img/banner2.5a00a31f.jpg";